import { render, staticRenderFns } from "./PointDepositComponent.vue?vue&type=template&id=7012c7e8&scoped=true&"
import script from "./PointDepositComponent.vue?vue&type=script&lang=js&"
export * from "./PointDepositComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7012c7e8",
  null
  
)

export default component.exports